import { createFileRoute } from '@tanstack/react-router';
import ChainDetailPage from '../../views/dashboard-chains/detail';

export const Route = createFileRoute('/dashboard/chains_/$chainUuid/')({
  component: ChainDetailPage,
});
